import { featureFlags } from "@config";

export default {
  canGenerateCourseImages: (): boolean => featureFlags.ai,
  canGenerateSkillImages: (): boolean => featureFlags.ai,
  canGenerateVideoCaptions: (): boolean => featureFlags.ai,
};
